import { type ReactElement, type SVGProps } from 'react';

export const BathroomPropertyIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8 3h3v3h2V3h3v1h-2v2h7v2.654C21 9.96 19.893 11 18.638 11H14v10h-1V11h-2v10h-1V11H5.34A2.361 2.361 0 0 1 3 8.654V6h7V4H8V3ZM4 7v1.654C4 9.394 4.624 10 5.34 10h13.298C19.362 10 20 9.387 20 8.654V7H4Z"
        clipRule="evenodd"
      />
    </svg>
  );
};
